import { Colonia } from '../interfaces/zip-model';
import { City } from '../interfaces/city-model';
import { State } from '../interfaces/states.model';
import moment from 'moment';
import { FormControl } from '@angular/forms';
import { IContactsUpdate } from '../interfaces/IContacts';

export function decideMunicipality(colonias: Colonia[], municipios: City[]) {
  let flag = false;
  let municipio;

  colonias.forEach((ele) => {
    if (ele.idCity !== '') {
      flag = true;
    }
  });

  if (flag) {
    let nombre = colonias[0].dmnpio;
    municipio = municipios.find((ele) => ele.cityDesc === nombre);
    return +municipio!.cityId;
  }

  return '';
}

export function fixStateId(idEstado: number, estados: State[]): number {
  return estados.find((ele) => ele.id === idEstado)!.idDaVinci!;
}

export function isYounger(control: FormControl) {
  let nacimiento = control.value;
  let now = moment();
  let edad = now.diff(nacimiento, 'years');

  return edad >= 16 ? null : { isMenor: true };
}

export function curpPattern() {
  let regex = '^([A-Z]{1}[AEIOUX]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1})?$';
  return regex;
}

export function rfcPattern() {
  let regex = '^[A-ZÑ&]{4}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])(?:[A-Z0-9]{3})$';
  return regex;
}

export function dateAfter(control: FormControl) {
  let date = moment(control.value).format('MMM DD YY');
  let now = moment().format('MMM DD YY');
  return date >= now ? null : { isBeforeDate: true };
}

export function separateSurnames(str: string) {
  let tokens = str.split(' ');

  // Arreglo donde se guardan las palabras del nombre.
  let names = new Array();

  // Palabras de apellidos y nombres compuestos
  const special_tokens = new Array(
    'da',
    'de',
    'del',
    'la',
    'las',
    'los',
    'mac',
    'mc',
    'van',
    'von',
    'y',
    'i',
    'san',
    'santa'
  );

  let prev = '';

  tokens.forEach((token: string) => {
    let _token = token.toLowerCase();
    if (special_tokens.includes(_token)) {
      prev = `${prev}${firstLetterUpperCase(_token)} `;
    } else {
      names.push(`${prev}${firstLetterUpperCase(_token)}`);
      prev = '';
    }
  });

  let num_nombres = names.length;

  let nombres = '', apellidos = '';

  switch (num_nombres) {
    case 1:
      nombres = names[0];
      break;
    case 2:
      nombres = names[0];
      apellidos = names[1];
      break;
    case 3:
      nombres = names[0];
      apellidos = `${names[1]} ${names[2]}`;
      break;
    case 4:
      nombres = `${names[0]} ${names[1]}`;
      apellidos = `${names[2]} ${names[3]}`;
      break;
    default:
      nombres = `${names[0]} ${names[1]}`;
      names.splice(0, 2);
      apellidos = names.join(' ');
      break;
  }

  return {
    motherName: apellidos,
    fatherName: nombres,
  };
}

export function firstLetterUpperCase(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function isInInvervalBound(estado: string) {
  const statesBound = [
    'E10', 'E11', 'E12', 'E13', 'E14', 'E15', 'E16',
    'E32', 'E33', 'E34', 'E35', 'E36', 'E37', 'E38',
    'E40', 'E41', 'E42', 'E43', 'E44', 'E45', 'E46'
  ];

  return statesBound.includes(`${estado}`);
}

export function returnFileSize(number: number) {
  if (number < 1024) {
    return number + ' bytes';
  } else if (number >= 1024 && number < 1048576) {
    return (number / 1024).toFixed(1) + ' Kb';
  } else if (number >= 1048576 && number <= 12582912) {
    return (number / 1048576).toFixed(1) + ' Mb';
  } else {
    return null;
  }
}


export function buildContacts(idKeycloak: string, email: boolean, sms: boolean, whats: boolean): IContactsUpdate {

  return {
    idKeycloak,
    contact: [
      { isCheck: email, key: 'C001' },
      { isCheck: sms, key: 'C002' },
      { isCheck: whats, key: 'C003' }
    ]
  }

}

/**
 * Valida si el parametro es nulo o indefinido
 * @export
 * @param {*} value
 * @author victor.mendez
 * @return {boolean} 
 */
export function _isNullOrUndefined(value: any): boolean {
  if (value === null || value === undefined || value === '') {
    return true;
  } else {
    return false;
  }
}

/**
   * Remueve los acentos en la cádena.
   * @param {string} str La cadena de texto a formatear.
   * @author victor.mendez@tipmexico.com
   * @return {string} 
   */
export function removeAccents(str: string): string {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

